import React from "react";
import { DisplayProps } from "models/propTypes/wintFormPropsTypes";
import { LocalizationHelperInstance } from "utils/helpers";
import ReadOnlyField from "../../forms/baseFields/readOnlyField";
import cssExports from "theme/styles/main.module.scss";

const DateWithDayDisplay: React.FC<DisplayProps> = (props: DisplayProps) => {
  const formattedDate = LocalizationHelperInstance.getFormattedDate(props.value);
  const dayName = LocalizationHelperInstance.getFormattedDate(props.value, { weekday: "long" });

  return (
    <ReadOnlyField label={props.label} className={cssExports.readOnlyTextField}>
      {formattedDate}
      <span className={cssExports.grayText} style={{ marginLeft: 8 }}>{dayName}</span>
    </ReadOnlyField>
  );
};

export default DateWithDayDisplay;
